import { createSelector } from 'reselect'

import type { TargetPageState } from './mappingSlice'

export const targetPageSelector = (state: RootState): TargetPageState => state.targetPage

export const botFieldsSelector = createSelector(
  targetPageSelector,
  ({ globalFields }) => globalFields.items || [],
)

export const userFieldsSelector = createSelector(
  targetPageSelector,
  ({ userFields }) => userFields.items || [],
)

export const userCustomEventsSelector = createSelector(
  targetPageSelector,
  ({ customEvents }) => customEvents.items || [],
)

export const tagsSelector = createSelector(targetPageSelector, ({ tags }) => tags.items || [])

export const otnsSelector = createSelector(targetPageSelector, ({ otns }) => otns.items || [])

export const tagsMapSelector = createSelector(targetPageSelector, ({ tagsMap }) => tagsMap)

export const cufsMapSelector = createSelector(targetPageSelector, ({ cufsMap }) => cufsMap)

export const gafsMapSelector = createSelector(targetPageSelector, ({ gafsMap }) => gafsMap)

export const otnsMapSelector = createSelector(targetPageSelector, ({ otnsMap }) => otnsMap)

export const customEventsMapSelector = createSelector(
  targetPageSelector,
  ({ customEventsMap }) => customEventsMap,
)
